module.exports = "<a href=\"\" tabindex=\"-1\" ng-bind-html=\"match.label | uibTypeaheadHighlight:query\" ng-attr-title=\"{{match.label}}\"></a>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/adapters/ui.bootstrap.typeahead/typeahead-match.jade
// module id = 864
// module chunks = 0